const listQuestions = {
  equalQuestion: [
    {
      id: 1,
      title: '1) Qual o principal motivo para o cancelamento do contrato?',
      radios: [
        { value: 'Problemas com o Imóvel', label: '1. Problemas com o Imóvel' },
        { value: 'Mudança de Endereço', label: '2. Mudança de Endereço' },
        {
          value: 'Problemas com a Imobiliária',
          label: '3. Problemas com a Imobiliária',
        },
        {
          value: 'Problemas com a CredPago',
          label: '4. Problemas com a CredPago',
        },
        { value: 'Imóvel Próprio', label: '5. Imóvel Próprio' },
        { value: 'Outros', label: '6. Outros' },
      ],
      valueRadio: 'question1Radio',
      valueText: 'question1Text',
    },

    {
      id: 2,
      title: '2) Qual a chance de indicar a CredPago para um amigo/familiar?',
      radios: [
        {
          value: 'Não indicaria',
          label: '1. Não indicaria',
        },
        {
          value: 'Talvez indicaria',
          label: '2. Talvez indicaria',
        },
        {
          value: 'Com certeza indicaria',
          label: '3. Com certeza indicaria',
        },
      ],
      valueRadio: 'question2Radio',
      valueText: '',
    },

    {
      id: 3,
      title: '3) Qual foi o seu nível de satisfação com o processo na locação deste imóvel?',
      radios: [
        { value: 'Nada Satisfeito', label: '1. Nada Satisfeito' },
        { value: 'Pouco Satisfeito', label: '2. Pouco Satisfeito' },
        { value: 'Satisfeito', label: '3. Satisfeito' },
        { value: 'Muito Satisfeito', label: '4. Muito Satisfeito' },
        {
          value: 'Extremamente Satisfeito',
          label: '5. Extremamente Satisfeito',
        },
      ],
      valueRadio: 'question3Radio',
      valueText: '',
    },

    {
      id: 4,
      title: '4) Em relação aos serviços da CredPago, você enfrentou algum desses problemas?',
      radios: [
        { value: 'Mal atendimento', label: '1. Mal atendimento' },
        {
          value: 'Demora no processo de locação',
          label: '2. Demora no processo de locação',
        },
        { value: 'Cobrança Indevida', label: '3. Cobrança Indevida' },
        {
          value: 'Nenhum problema com os serviços da CredPago',
          label: '4. Nenhum problema com os serviços da CredPago',
        },
        { value: 'Outros', label: '5. Outros' },
      ],
      valueRadio: 'question4Radio',
      valueText: 'question4Text',
    },

    {
      id: 5,
      title: '5) Em relação ao atendimento da imobiliária qual foi o seu nível de satisfação?',
      radios: [
        { value: 'Nada Satisfeito', label: '1. Nada Satisfeito' },
        { value: 'Pouco Satisfeito', label: '2. Pouco Satisfeito' },
        { value: 'Satisfeito', label: '3. Satisfeito' },
        { value: 'Muito Satisfeito', label: '4. Muito Satisfeito' },
        {
          value: 'Extremamente Satisfeito',
          label: '5. Extremamente Satisfeito',
        },
      ],
      valueRadio: 'question5Radio',
      valueText: '',
    },
  ],
};

export default listQuestions;
